import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query'
import { pcgPublicApi } from 'services/pcgPublic';
import { pcgPublicV2Api } from 'services/pcgPublicV2';

export const store = configureStore({
  reducer: {
    [pcgPublicApi.reducerPath]: pcgPublicApi.reducer,
    [pcgPublicV2Api.reducerPath]: pcgPublicV2Api.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(pcgPublicApi.middleware)
      .concat(pcgPublicV2Api.middleware),
});

setupListeners(store.dispatch)

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
